import * as util from "../other/util.js";

// A toast pop up at the bottom of the screen, to show messages to the user.
export default class ToastView extends util.GameComponent {
   constructor(props) {
      super(props);
      this.state = {
         toast: null
      };

      // Global hook to show a toast message
      util.toastHandler.callback = (toast) => {
         this.setState({ toast: toast });
      }
   }

   render() {
      if (!this.state.toast) {
         return null;
      }

      // co
      const content = this.state.toast.content;
      const hint = this.state.toast.hint || "";
      const word_count = (content + hint).split(" ").length;

      setTimeout(() => {
         this.setState({ toast: null });
      }, word_count * 250 + 4000); // Show for 750ms per word, plus 1 second extra

      return (
         <div className="toast-container">
            <div className="toast-message">
               <p>{content}</p>
               <div className="hint-box">Hint: {hint}</div>
            </div>
         </div>
      );
   }
}
